// extracted by mini-css-extract-plugin
module.exports = {"toast":"toast_toast__h70k2","fadeIn":"toast_fadeIn__rEb6m"};